/**
 * Lazy-loaded versions of coverage blurbs components.
 * Use these in components that don't always render coverage blurbs (like stream mastheads)
 * to avoid loading emoji-picker-react and other heavy dependencies on initial page load.
 */
import loadable from '@loadable/component';
import type * as CoverageBlurbsModule from './coverageBlurbs';

export const LazyLoadableCoverageBlurbs = loadable(() => import('./coverageBlurbs'), {
  resolveComponent: (module: typeof CoverageBlurbsModule) => module.LoadableCoverageBlurbs,
  fallback: null
});

export const LazyGridCoverageBlurbs = loadable(() => import('./coverageBlurbs'), {
  resolveComponent: (module: typeof CoverageBlurbsModule) => module.GridCoverageBlurbs,
  fallback: null
});
